// src/components/CookiePolicy.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaCookieBite } from 'react-icons/fa';

const CookiePolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <Link 
        to="/" 
        className="flex items-center gap-2 text-blue-600 hover:text-blue-800 mb-6"
      >
        <FaArrowLeft /> Back to Home
      </Link>

      <div className="bg-white rounded-lg shadow-md p-8">
        <div className="flex items-center gap-3 mb-6">
          <FaCookieBite className="text-2xl text-amber-600" />
          <h1 className="text-3xl font-bold text-gray-800">Cookie Policy</h1>
        </div>

        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">What Are Cookies</h2>
            <p className="text-gray-700">
              As is common practice with almost all professional websites, this site uses cookies, 
              which are tiny files that are downloaded to your computer, to improve your experience. 
              This page describes what information they gather, how we use it, and why we sometimes 
              need to store these cookies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">How We Use Cookies</h2>
            <p className="text-gray-700 mb-4">
              We use cookies for a variety of reasons detailed below. Unfortunately, in most cases, 
              there are no industry standard options for disabling cookies without completely disabling 
              the functionality and features they add to this site.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Disabling Cookies</h2>
            <p className="text-gray-700">
              You can prevent the setting of cookies by adjusting the settings on your browser. 
              Be aware that disabling cookies will affect the functionality of this and many other 
              websites that you visit.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">The Cookies We Set</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Account-related cookies:</strong> Used to manage the signup process and general administration.</li>
              <li><strong>Login-related cookies:</strong> Used when you are logged in to prevent having to log in every single page.</li>
              <li><strong>Order processing cookies:</strong> To remember your order details between pages.</li>
              <li><strong>Site preferences cookies:</strong> To provide a great experience by remembering your preferences.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Third-Party Cookies</h2>
            <p className="text-gray-700 mb-4">In some special cases, we also use cookies provided by trusted third parties, including:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Google Analytics cookies to understand how you use our site</li>
              <li>Social media buttons cookies that allow you to share content</li>
              <li>Payment processing cookies to enable secure transactions</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">More Information</h2>
            <p className="text-gray-700">
              If you are looking for more information, you can contact us through one of our preferred 
              contact methods: Email: <a href="mailto:privacy@ressde.in" className="text-blue-600 hover:underline">privacy@ressde.in</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;